exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.menu {}\n\na.first {\n  margin-left: 0;\n}\n\na, a:visited {\n  display: inline-block;\n  color: #E8F4E4;\n  padding-top: 2ex;\n  padding-bottom: 2ex;\n  padding-left: 2em;\n  padding-right: 2em;\n  text-transform: uppercase;\n  font-weight: bold;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\na.current, a.current:hover {\n  background: white;\n  color: #444;\n  border-radius: 6px 6px 0 0;\n  text-decoration: none;\n  cursor: default;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/main-menu/main-menu.component.css
// module id = ../../../../../src/app/main-menu/main-menu.component.css
// module chunks = main